
const loanApprovalTem = [
  {
    type: 'input',
    field: 'applicant',
    label: '申请人',
    vModel: 'field2',
  },
  {
    type: 'input',
    field: 'applicantDept',
    label: '部门',
    vModel: 'field3',
  },
  {
    type: 'input',
    field: 'loanType',
    label: '借款类型',
    vModel: 'field4',
  },
  {
    type: 'input',
    field: 'loanOwnershipName',
    label: '项目名称',
    vModel: 'field5',
  },
  {
    type: 'input',
    field: 'projectNo',
    label: '项目编号',
    vModel: 'field6',
  },
  {
    type: 'input',
    field: 'budget',
    label: '预算执行',
    vModel: 'field7',
  },
  {
    type: 'input',
    field: 'reasonsBorrowing',
    label: '借款事由',
    vModel: 'field8',
  },
  {
    type: 'input',
    field: 'expectedReturnDate',
    label: '预计归还日期',
    format: "YYYY-MM-DD",
    date: true,
    vModel: 'field9',
  },
  {
    type: 'list',
    field: 'loanPayee',
    label: '收款人信息',
    vModel: 'field10',
  },
  {
    type: 'list',
    field: 'loanDetails',
    label: '借款明细',
    vModel: 'field11',
  },
  {
    type: 'file',
    field: 'fileList',
    label: '附件',
    vModel: 'field12',
  },
  {
    type: 'input',
    field: 'expenseAmountTotal',
    label: '合计总额（元）',
    vModel: 'field13',
  }
]

const exprensiveClaimTem = [
  {
    type: 'input',
    field: 'applicantName',
    label: '申请人',
    vModel: 'field2',
  },
  {
    type: 'input',
    field: 'applicationDepartmentName',
    label: '部门',
    vModel: 'field3',
  },
  {
    type: 'input',
    field: 'reimbursementType',
    label: '报销类型',
    vModel: 'field4',
  },
  {
    type: 'input',
    field: 'costAttributionName',
    label: '项目名称',
    vModel: 'field5',
  },
  {
    type: 'input',
    field: 'projectNo',
    label: '项目编号',
    vModel: 'field6',
  },
  {
    type: 'input',
    field: 'budgetExecutionType',
    label: '预算执行',
    vModel: 'field7',
  },
  {
    type: 'input',
    field: 'reasons',
    label: '报销事由',
    vModel: 'field8',
  },
  {
    type: 'list',
    field: 'costPayee',
    label: '收款人',
    vModel: 'field9',
  },
  {
    type: 'list',
    field: 'costDetails',
    label: '报销明细',
    vModel: 'field10',
  },
  {
    type: "input",
    field: "loanBillId",
    label: "借款单",
    vModel: 'field11'
  },
  {
    type: "input",
    field: "originalLoan",
    label: "借款金额",
    vModel: 'field12'
  },
  {
    type: 'input',
    field: 'expenseAmountTotal',
    label: '合计总额（元）',
    vModel: 'field13',
  },
  {
    type: 'input',
    field: 'balance',
    label: '报销单付款',
    vModel: 'field14',
  },
  {
    type: 'file',
    field: 'fileList',
    label: '附件',
    vModel: 'field15',
  },
  {
    type: "input",
    field: "relateApprovalNo",
    label: "关联审批单",
    vModel: 'field16'
  },
]

const paymentClaimTem = [
  {
    type: 'input',
    field: 'applicantName',
    label: '申请人',
    vModel: 'field2',
  },
  {
    type: 'input',
    field: 'applicationDepartmentName',
    label: '部门',
    vModel: 'field3',
  },
  {
    type: 'input',
    field: 'billType',
    label: '单据类型',
    vModel: 'field4',
  },
  {
    type: 'input',
    field: 'costAttributionName',
    label: '项目名称',
    vModel: 'field5',
  },
  {
    type: 'input',
    field: 'projectNo',
    label: '项目编号',
    vModel: 'field6',
  },
  {
    type: 'input',
    field: 'budgetExecutionType',
    label: '预算执行',
    vModel: 'field7',
  },
  {
    type: 'input',
    field: 'contactCompany',
    label: '往来单位',
    vModel: 'field8',
  },
  {
    type: 'input',
    field: 'currencyName',
    label: '币种',
    vModel: 'field9',
  },
  {
    type: 'input',
    field: 'settlementName',
    label: '结算方式',
    vModel: 'field10',
  },
  {
    type: 'input',
    field: 'remark',
    label: '付款事由',
    vModel: 'field11',
  },
  {
    type: 'list',
    field: 'payee',
    label: '收款人',
    vModel: 'field12',
  },
  {
    type: 'list',
    field: 'detail',
    label: '付款申请详细',
    vModel: 'field13',
  },
  {
    type: 'input',
    field: 'relationBillType',
    label: '关联单据类型',
    vModel: 'field14',
  },
  {
    type: 'input',
    field: 'relationBillNo',
    label: '关联单据',
    vModel: 'field15',
  },
  {
    type: 'input',
    field: 'expenseAmountTotal',
    label: '合计总额（元）',
    vModel: 'field16',
  },
  {
    type: 'file',
    field: 'fileList',
    label: '附件',
    vModel: 'field17',
  },
]

const travelClaimTem = [
  {
    type: 'input',
    field: 'applicantUname',
    label: '申请人',
    vModel: 'field2'
  },
  {
    type: 'input',
    field: 'departmentName',
    label: '部门',
    vModel: 'field3'
  },
  {
    type: 'input',
    field: 'attributionName',
    label: '项目名称',
    vModel: 'field4'
  },
  {
    type: 'input',
    field: 'projectNo',
    label: '项目编号',
    vModel: 'field5',
  },
  {
    type: 'input',
    field: 'budgetName',
    label: '预算执行',
    vModel: 'field6'
  },
  {
    type: 'input',
    field: 'reasons',
    label: '报销事由',
    vModel: 'field7'
  },
  {
    type: 'list',
    field: 'payee',
    label: '收款人',
    vModel: 'field8'
  },
  {
    type: 'list',
    field: 'detail',
    label: '报销明细',
    vModel: 'field9'
  },
  {
    type: "input",
    field: "loanCode",
    label: "借款单",
    vModel: 'field10'
  },
  {
    type: "input",
    field: "originalLoan",
    label: "借款金额",
    vModel: 'field11'
  },
  {
    type: 'input',
    field: 'expenseAmountTotal',
    label: '合计总额（元）',
    vModel: 'field12'
  },
  {
    type: 'input',
    field: 'balance',
    label: '报销单付款',
    vModel: 'field13',
  },
  {
    type: 'file',
    field: 'fileList',
    label: '附件',
    vModel: 'field14',
  },
  {
    type: "input",
    field: "relateApprovalNo",
    label: "出差审批单",
    vModel: 'field15'
  },
]

const receiveClaimTem = [
  {
    type: 'input',
    field: 'applicantUname',
    label: '申请人',
    vModel: 'field2'
  },
  {
    type: 'input',
    field: 'departmentName',
    label: '部门',
    vModel: 'field3'
  },
  {
    type: 'input',
    field: 'attributionName',
    label: '项目名称',
    vModel: 'field4'
  },
  {
    type: 'input',
    field: 'projectNo',
    label: '项目编号',
    vModel: 'field5',
  },
  {
    type: 'input',
    field: 'budgetName',
    label: '预算执行',
    vModel: 'field6'
  },
  {
    type: 'input',
    field: 'reasons',
    label: '用途描述',
    vModel: 'field7'
  },
  {
    type: 'input',
    field: 'drawAmount',
    label: '领款金额（元）',
    vModel: 'field8'
  },
  {
    type: 'file',
    field: 'fileList',
    label: '附件',
    vModel: 'field9',
  },
]

export const FormTem = {
  loanApprovalTem,
  exprensiveClaimTem,
  paymentClaimTem,
  travelClaimTem,
  receiveClaimTem
};
